import { mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  methods: {
    formatToMerchantTimeZone(timeToFormat, timeOnly) {
      if (timeToFormat && !!this.merchantTimeZone && !!moment.tz) {
        const utcTime = moment.utc(timeToFormat),
          momentTzDate = utcTime.tz(this.merchantTimeZone),
          dateFormatted = momentTzDate ? momentTzDate.format('MM/DD/YY') : '--',
          timeFormatted = momentTzDate ? momentTzDate.format('h:mma') : '--'
        return timeOnly ? timeFormatted : `${dateFormatted} at ${timeFormatted}`
      }
    },

    formatDateOnly(dateToFormat) {
      if (dateToFormat && !!this.merchantTimeZone && !!moment.tz) {
        const utcTime = moment.utc(dateToFormat),
          momentTzDate = utcTime.tz(this.merchantTimeZone)
        return momentTzDate ? momentTzDate.format('MM/DD/YY') : '--'
      }
    },

    formatTime(timeToFormat) {
      if (timeToFormat && !!moment.tz) {
        return moment.utc(timeToFormat).format('h:mma')
      }
    },
  },

  computed: {
    ...mapGetters([
      'merchantTimeZone'
    ]),
  },
}